<template>
  <v-dialog v-model="dialog" scrollable persistent>
    <v-card class="cardStyle">
      <v-card-text class="titleCard" style="padding: 15px">
        <v-container fluid style="height: 100%">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <h5>{{ $t('My NIF/CIF') }}</h5>
            <v-text-field
              ref="formCif"
              v-model="cif"
              :rules="rules.cif"
              required
              name="cif"
              type="text"
            />
          </v-form>
        </v-container>
      </v-card-text>


      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="!valid || !cif || cif === ''"
          class="btnYes"
          text
          @click="saveDecision()"
        >
          {{ $t('Save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import Constants from "../../constants";

export default {
    name: 'UserMissingCif',
    data: () => ({
        dialog: false,
        user: null,
        name: '',
        surname: '',
        phone: '',
        email: '',
        address: '',
        cif: '',
        dontShowAgain: false,
        valid: false,
        country: 'Spain',
        isFactor: false,
        isAdmin: false,
        payerComission: 0,
        receiverComission: 0,
        platformComission: 0,
        rules: {
            cif: [
                val => (val || '').length > 0 || 'This field is required',
                //v => /^[a-zA-Z0-9]{1}[0-9]{7}[a-zA-Z0-9]{1}$/.test(v) || 'The CIF must be valid (Example formats: A12345678, 12345678B, C1234567D)'
            ]
        },
    }),
    created () {
        this.$root.$on('check-user-cif', (id) => {
            this.initForm(id);
        });
        if (this.$user) {
            this.initForm(this.$user._id);
        }
    },
    methods: {
        initForm (id) {
            ApiRepository.getUserById(id)
                .then((res) => {
                    this.user = res.data.user;
                    this.cif = this.user.cif;
                    this.name = this.user.name;
                    this.surname = this.user.surname;
                    this.phone = this.user.phone;
                    this.email = this.user.email;
                    this.address = this.user.address;
                    this.country = this.user.country;
                    this.isFactor = this.user.role === Constants.USER.ROLE_FACTOR;
                    this.isAdmin = this.user.role === Constants.USER.ROLE_ADMIN;

                    this.dialog = !this.cif;
                })
                .catch((err) => {
                    console.log(err);
                    this.$root.$emit('show-snackbar', {message: this.$t('Error.User not found'), color: 'error'});
                });
        },
        saveDecision () {
            let newRole;
            if (this.isAdmin) {
                newRole = Constants.USER.ROLE_ADMIN;
            } else if (this.isFactor) {
                newRole = Constants.USER.ROLE_FACTOR;
            } else {
                newRole = Constants.USER.ROLE_USER;
            }
            ApiRepository.saveUser(this.cif, this.name, this.surname, this.phone, this.email, this.address, this.country, newRole, this.$user._id, this.payerComission, this.receiverComission, this.platformComission)
                .then(() => {
                    ApiRepository.getParameters().then((res) => {
                        if (res && res.data && res.data.params) {
                            this.$parameters = res.data.params;
                            this.payerComission = this.$parameters.payerComission;
                            this.receiverComission = this.$parameters.receiverComission;
                            this.platformComission = this.$parameters.platformComission;
                        }
                        this.dialog = false;
                        this.$root.$emit('show-splash-check', this.cif);
                    }).catch((err) => {
                        console.log(err);
                    }).finally(() => {
                        this.$root.$emit('show-snackbar', {message: this.$t('Saved successfully!')});
                        this.$emit('success');
                    });

                })
                .catch((err) => {
                    let miss = "";
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAME_CIF) {
                        miss = this.$t('Already exists a user with this CIF');
                    } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAME_MAIL) {
                        miss = this.$t('Already exists a user with this Email');
                    } else {
                        miss = this.$t('Error.Something went wrong');
                    }
                    this.$root.$emit('show-snackbar', {message: miss, color: 'error'});
                    this.$emit('error');
                    console.error(err);
                });
        }
    }
};
</script>
<style>

</style>
